
import { RemoveMessage } from '@/core/helper/validation-rule-helper';
import { t } from 'i18next';
import { useCallback, useEffect, useMemo, useRef, useState } from 'react'
// import DataGridWrapper from '@/core/wrappers/data-grid-wrapper';
import DataGridWrapper from '../../syncflow/components/data-grid-wrapper';
import CustomStore from 'devextreme/data/custom_store';
import React from 'react';
import { Button } from 'devextreme-react/button';
import { DataGrid, Popup, TextBox } from 'devextreme-react';
import { supplierOrderListService } from '../services/supplier-order-list-service';
import { DataGridTypes } from 'devextreme-react/cjs/data-grid';
import { toast } from 'react-toastify';
import { alert, confirm } from 'devextreme/ui/dialog';
import {
    Validator,
    RequiredRule,
} from 'devextreme-react/validator';
import { useNavigate } from 'react-router-dom';
import { useParams } from 'react-router-dom';
import { IOrderDetail } from '@/core/interfaces/usestate-interfaces';
import moment from 'moment';
import { TextBoxTypes } from 'devextreme-react/cjs/text-box';
import { left, right } from '@popperjs/core';
import ArrayStore from 'devextreme/data/array_store';

function SupplierOrderDetail() {

    const dataGridRef = useRef<DataGrid>(null);
    const validatorRef = useRef<Validator>(null);

    const [store, setStore] = useState<CustomStore>();

    useEffect(() => {
        setStore(new CustomStore({
            key: ["orderLineId"],
            load: onGetOrderData,
            useDefaultSearch: true
        }));
    }, [])


    const params = useParams();
    let strOrNumber: string | number = "";
    const onGetOrderData = useCallback(async () => {
        fetchAccounts();
        strOrNumber = params.id != undefined ? params.id : "";
        const x = await supplierOrderListService.getOrderDetailList(parseInt(strOrNumber));
        return x;
    }, []);


    const [account, setAccount] = useState<IOrderDetail>();
    const fetchAccounts = async () => {
        strOrNumber = params.id != undefined ? params.id : "";
        const data = await supplierOrderListService.getOrderDetail(parseInt(strOrNumber));
        setAccount(data)
    };


    const onFocusedCellChanging = (e: { isHighlighted: boolean; }) => {
        e.isHighlighted = true;
    };

    const navigate = useNavigate();
    const goToBack = () => {
        navigate(`/b2b/supplier-order-list`)
    }


    const [selectedRowKeys, setSelectedRowKeys] = useState<any | null>(null);
    const onSelectionChanged = (args: DataGridTypes.SelectionChangedEvent) => {
        setSelectedRowKeys(args.selectedRowKeys);
    };

    async function approveFunc() {

        let result = await confirm(t("syncflow:msg_approve_confirm_supplier"), t("syncflow:ti_confirm"));
        if (!result) return;

        if (dataGridRef.current?.instance.hasEditData()) {
            let result = confirm(t("syncflow:msg_save_confirm"), t("syncflow:ti_confirm"));
            result.then((dialogResult) => {
                if (dialogResult) {
                    dataGridRef.current?.instance.saveEditData().then(x => {
                        //save
                        dataGridRef.current?.instance.refresh().then(x => {
                            dataGridRef.current?.instance.cancelEditData();
                            supplierOrderListService
                                .order_approve(account?.orderId)
                                .then((response) => {
                                    toast.success(t("syncflow:msg_saved"));
                                    dataGridRef.current?.instance.refresh();
                                })
                        }
                        );
                    });
                }
                else {
                    dataGridRef.current?.instance.cancelEditData();
                    dataGridRef.current?.instance.refresh();
                    supplierOrderListService
                        .order_approve(account?.orderId)
                        .then((response) => {
                            toast.success(t("syncflow:msg_saved"));
                            dataGridRef.current?.instance.refresh();
                        })
                }
            });
        }
        else { 
            supplierOrderListService
                .order_approve(account?.orderId)
                .then((response) => {
                    toast.success(t("syncflow:msg_saved"));
                    dataGridRef.current?.instance.refresh();
                })
        }
    }

    function declineFunc() {

        validatorRef.current?.instance.validate();
        if (reasonValue != "") {
            supplierOrderListService.order_reject(account != undefined ? account.orderId : 0, reasonValue).then((response) => {
                dataGridRef.current?.instance.refresh();
                toast.success(t("syncflow:msg_saved"));
                hideInfo();
            })
        }
    }

    const onSave = async () => {
        if (dataGridRef.current?.instance.hasEditData()) {
            let result = confirm(t("syncflow:msg_save_confirm"), t("syncflow:ti_confirm"));
            result.then((dialogResult) => {
                if (dialogResult) {
                    dataGridRef.current?.instance.saveEditData().then(x => {
                        //save
                        dataGridRef.current?.instance.refresh().then(x => dataGridRef.current?.instance.cancelEditData());
                    });
                }
            });
        }
    }

    const onSaving = (e: DataGridTypes.SavingEvent) => {
        e.cancel = true;
        if (e.changes.length > 0) {
            supplierOrderListService.updatePreorderBatch(e.changes).then((response) => {
                toast.success(t("syncflow:msg_saved"));
            });
        }
    }




    const onCellPrepared = async (e: any) => {
        if (e.hasOwnProperty("data")) {
            if ((e.column.dataField === 'orderLinesApprovedQty') && e.data.orderLineStatusCode == "N") {
                e.cellElement.style.backgroundColor = '#E6F1FF';
            }
        }
    };






    function validateApproveAndReason(e: any) {
        if (e.data.orderQty != e.data.orderLinesApprovedQty && e.data.orderLineReasonCode == undefined) { return false }
        else { return true }
    }

    function onEditorPreparing(e: any) {
        if (e.parentType === "dataRow" && e.dataField === "orderLinesApprovedQty") {
            e.editorOptions.onValueChanged = function (args: any) {
                e.setValue && e.setValue(args.value, e)

                if (args.value != e.row.data.orderQty) {
                    let result = alert(t("syncflow:msg_select_reason"), t("syncflow:ti_confirm"));
                    result.then(() => {
                        e.component.editCell(e.row.rowIndex, "orderLineReasonCode");
                    });
                }
            };
        }
    }



    const [popupVisible, setPopupVisible] = useState(false);

    const hideInfo = useCallback(() => {
        setPopupVisible(false);
    }, [setPopupVisible]);

    const showInfo = useCallback(() => {
        let result = confirm(t("syncflow:msg_approve_reject_supplier"), t("syncflow:ti_confirm"));
        result.then((dialogResult) => {
            if (dialogResult) {
                setPopupVisible(true);
            }
        });
    }, [setPopupVisible]);

    const orderReasonsData = [
        { code: "1001", name: t('syncflow:lb_order_line_reason_status_1001') },
        { code: "2001", name: t('syncflow:lb_order_line_reason_status_2001') },
        { code: "3001", name: t('syncflow:lb_order_line_reason_status_3001') },
        { code: "4001", name: t('syncflow:lb_order_line_reason_status_4001') },
        { code: "5001", name: t('syncflow:lb_order_line_reason_status_5001') },
        { code: "6001", name: t('syncflow:lb_order_line_reason_status_6001') },
    ];

    const [orderReasonsLookup] = useState(new ArrayStore({
        key: 'code',
        data: orderReasonsData
    }));

    const onEditingStart = (e: any) => {
        if (e.column.dataField == "orderLinesApprovedQty") {
            if (e.data.orderLineStatusCode != "N") {
                e.cancel = true;
            }
        }

        if (e.column.dataField == "orderLineReasonCode") {
            if (e.data.orderLinesApprovedQty == e.data.orderQty) {
                e.cancel = true;
            } else {
                e.cancel = false;
            }
        }
    }

    let [reasonValue, setValue] = useState('');
    const nameLabel = { 'aria-label': 'Name' };
    const valueChanged = useCallback((data: TextBoxTypes.ValueChangedEvent) => {
        setValue(data.value);
    }, []);

    //moment.locale('tr');
    const calculate_approved_amount_cell = (data: any) => (data.price * data.orderLinesApprovedQty);
    return (
        <>

            <div id="container">

                <Popup
                    visible={popupVisible}
                    onHiding={hideInfo}
                    dragEnabled={false}
                    hideOnOutsideClick={true}
                    showCloseButton={false}
                    showTitle={true}
                    title="Information"
                    container="#container"
                    width={500}
                    height={200}
                >


                    <TextBox
                        onValueChanged={valueChanged}
                        inputAttr={nameLabel}
                        showClearButton={true}
                        placeholder={t("syncflow:msg_select_reason")}
                    >
                        <Validator ref={validatorRef}>
                            <RequiredRule message={t("syncflow:msg_reason_required")} />
                        </Validator>
                    </TextBox>

                    <div style={{ marginTop: 30, float: left }}>
                        <Button
                            text={t("syncflow:btn_reject")}
                            type="default"
                            stylingMode="contained"
                            icon="close"
                            onClick={declineFunc}
                        />
                    </div>

                    <div style={{ marginTop: 30, float: right }}>
                        <Button
                            text={t("syncflow:btn_cancel")}
                            type="default"
                            stylingMode="contained"
                            onClick={hideInfo}
                        />
                    </div>

                </Popup>
            </div>

            <div className='row mb-4 justify-content-end'>
                <div className='col-auto'>
                    <div className='col-auto'>
                        <Button
                            text={t("syncflow:btn_back")}
                            type="default"
                            icon="back"
                            stylingMode="contained"
                            onClick={goToBack}
                        />
                    </div>
                </div>
                <div className='col-auto'>
                    <Button
                        text={t("syncflow:btn_save")}
                        type="default"
                        icon="save"
                        onClick={onSave}
                        visible={account?.orderStatusCode != "N" ? false : true}
                    />
                </div>

                <div className='col-auto'>
                    <Button
                        text={t("syncflow:btn_approve")}
                        type="normal"
                        stylingMode="contained"
                        icon="check"
                        onClick={approveFunc}
                        style={{ backgroundColor: 'green', color: 'white' }}
                        visible={account?.orderStatusCode != "N" ? false : true}
                    />
                </div>

                <div className='col-auto'>
                    <Button
                        className='btnDecline'
                        text={t("syncflow:btn_reject")}
                        type="normal"
                        stylingMode="contained"
                        icon="close"
                        onClick={showInfo}
                        style={{ backgroundColor: 'red', color: 'white' }}
                        visible={account?.orderStatusCode != "N" ? false : true}
                    />
                </div>
            </div>


            <div className="card-body py-3">
                <div className="table-responsive">
                    <table className="table table-row-dashed table-row-gray-300 align-middle gs-0 gy-4">
                        <thead>
                            <tr className="fw-bold text-muted">
                                <th className="w-25px">
                                    <div className="form-check form-check-sm form-check-custom form-check-solid"></div>
                                </th>
                                <th className="min-w-150px">{t('syncflow:lb_type')}</th>
                                <th className="min-w-120px">{t('syncflow:lb_order_number')}</th>
                                <th className="min-w-120px">{t('syncflow:lb_order_date')}</th>
                                <th className="min-w-120px">{t('syncflow:lb_delivery_date')}</th>
                                <th className="min-w-120px">{t('syncflow:lb_customer')}</th>
                                <th className="min-w-120px">{t('syncflow:lb_source_name')}</th>
                                <th className="min-w-120px">{t('syncflow:lb_product_count')}</th>
                                <th className="min-w-120px">{t('syncflow:lb_order_quantity')}</th>
                                <th className="min-w-120px">{t('syncflow:lb_order_amount')}</th>
                                <th className="min-w-120px">{t('syncflow:lb_supplier_approved_quantity')}</th>
                                <th className="min-w-120px">{t('syncflow:lb_supplier_approved_amount')}</th>
                                <th className="min-w-120px">{t('syncflow:lb_order_supplier_status')}</th>
                            </tr>
                        </thead>
                        <tbody>
                            <tr>
                                <td>
                                    <div className="form-check form-check-sm form-check-custom form-check-solid"></div>
                                </td>
                                <td><span className="text-gray-900 fw-bold text-hover-primary d-block fs-6">{t('syncflow:lb_order_type_'+(account?.orderTypeCode))}</span></td>
                                <td><span className="text-gray-900 fw-bold text-hover-primary d-block fs-6">{(account?.orderCode)}</span></td>
                                <td><span className="text-gray-900 fw-bold text-hover-primary d-block fs-6">{(moment(account?.orderDate).format("DD/MM/YYYY"))}</span></td>
                                <td><span className="text-gray-900 fw-bold text-hover-primary d-block fs-6">{(moment(account?.deliveryDate).format("DD/MM/YYYY"))}</span></td>
                                <td><span className="text-gray-900 fw-bold text-hover-primary d-block fs-6">{(account?.retailerAccountName)}</span></td>
                                <td><span className="text-gray-900 fw-bold text-hover-primary d-block fs-6">{(account?.retailerSourceName)}</span></td>
                                <td><span className="text-gray-900 fw-bold text-hover-primary d-block fs-6">{(account?.productCount)}</span></td>
                                <td><span className="text-gray-900 fw-bold text-hover-primary d-block fs-6">{(account?.orderQty)}</span></td>
                                <td><span className="text-gray-900 fw-bold text-hover-primary d-block fs-6">${(account?.amount)}</span></td>
                                <td><span className="text-gray-900 fw-bold text-hover-primary d-block fs-6">{(account?.vendorApprovedQty)}</span></td>
                                <td><span className="text-gray-900 fw-bold text-hover-primary d-block fs-6">${(account?.vendorAmount)}</span></td>
                                <td><span className="text-gray-900 fw-bold text-hover-primary d-block fs-6">{t('syncflow:lb_order_supplier_status_' + account?.orderStatusCode)} </span></td>
                            </tr>
                        </tbody>
                    </table>
                </div>
            </div>


            <React.Fragment>
                <DataGridWrapper
                    props={{ ref: dataGridRef }}
                    datasource={store}
                    columnChooser={true}
                    remoteOperations={false}
                    showColumnLines={true}
                    onSaving={onSaving}
                    pagerVisible={true}
                    // onCellEditingStart={onCellEditingStart}
                    onSelectionChanged={onSelectionChanged}
                    onCellPrepared={onCellPrepared}
                    onEditorPreparing={onEditorPreparing}
                    onEditingStart={onEditingStart}
                    //selectionConfig={{ mode: 'multiple', selectAllMode: 'allPages', showCheckBoxesMode: 'always' }}
                    filterVisible={true}
                    headerFilterVisible={true}
                    keyboardNavigation={true}
                    onFocusedCellChanging={onFocusedCellChanging}
                    editingConfig={{
                        mode: "batch",
                        useIcons: true,
                        allowAdding: false,
                        allowDeleting: false,
                        allowUpdating: true,
                        updateMessageText: RemoveMessage('Resource'),
                    }}


                    columns={[
                        {
                            dataField: 'retailerProductCode',
                            caption: t('syncflow:lb_product_code'),
                            allowFiltering: true,
                            allowEditing: false,
                            visible: false
                        },
                        {
                            dataField: 'retailerProductName',
                            caption: t('syncflow:lb_product_name'),
                            allowFiltering: true,
                            allowEditing: false,
                        },
                        /* {
                             dataField: 'productBarcode',
                             caption: t('syncflow:lb_product_barcode'),
                             allowFiltering: true,
                             allowEditing: false,
                         },*/
                        {
                            dataField: 'unit',
                            caption: t('syncflow:lb_measurement_unit_code'),
                            allowFiltering: true,
                            allowEditing: false,
                        },
                        {
                            dataField: 'orderQty',
                            caption: t('syncflow:lb_order_quantity'),
                            allowFiltering: true,
                            allowEditing: false,
                        },
                        {
                            dataField: 'orderLinesApprovedQty',
                            caption: t('syncflow:lb_approved_order_quantity'),
                            allowFiltering: true,
                            allowEditing: true,
                        },

                        {
                            dataField: 'orderLineReasonCode',
                            caption: t('syncflow:lb_order_line_reason_name'),
                            allowFiltering: true,
                            allowEditing: true,
                            customRequired: true,
                            callFunc: validateApproveAndReason,
                            customErrorMessage: t('syncflow:msg_reason_required'),
                            lookup: {
                                dataSource: orderReasonsLookup,
                                valueExpr: "code",
                                displayExpr: "name"
                            }
                        },
                        {
                            dataField: 'price',
                            caption: t('syncflow:lb_product_price'),
                            allowFiltering: true,
                            allowEditing: false,
                            format: { style: "currency", currency: "USD", useGrouping: true }
                        },
                        {
                            dataField: 'amount',
                            caption: t('syncflow:lb_order_amount'),
                            allowFiltering: true,
                            allowEditing: false,
                            format: { style: "currency", currency: "USD", useGrouping: true }
                        },
                        {
                            dataField: 'approvedAmount',
                            caption: t('syncflow:lb_supplier_approved_amount'),
                            allowFiltering: true,
                            allowEditing: false,
                            format: { style: "currency", currency: "USD", useGrouping: true },
                            calculateCellValue: calculate_approved_amount_cell
                        },

                    ]}
                />
            </React.Fragment>

        </>


    )
}
export default SupplierOrderDetail
